import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Stack } from 'react-bootstrap';
import { HiLocationMarker } from 'react-icons/hi';
import { BiLogoGmail } from 'react-icons/bi';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaRegCopyright } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = ({ scrollToAboutUs, scrollToFeature, scrollToHowItWorks, scrollToFAQ ,scrollToContactUs}) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let navbarClasses = ['navChild'];
    if (scrolled) {
        navbarClasses.push('scrolled');
    }

    return (
        <>
            <footer className="mt-5 mb-5">
                <Container>
                    <Row>
                        {/* Left side logo */}
                        <Col xs={12} md={6} className="text-center text-md-start mb-3 mb-md-0">
                        <img src="/fexperience/assets/video/MainLogo.png" className='img-fluid MainLogo' alt="" />
                        </Col>

                        {/* Right side links */}
                        <Col xs={12} md={6} className="text-center text-md-end">
                            <a href="/" className="me-3 text-black TD-none">Home</a>
                            <Link onClick={scrollToAboutUs} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>About Us</Link>
                            <Link onClick={scrollToFeature} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>Features</Link>
                            <Link onClick={scrollToHowItWorks} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>How it Works</Link>
                            <Link onClick={scrollToFAQ} href="/" className='text-black navLinkHover fontWeight-800 mx-2'>FAQs</Link>
                        </Col>

                    </Row> 

                    {/* Social media icons */}
                    <Row className="mt-3 mb-3">
                    <Col xs={12} md={6} className="text-center text-md-start mb-3 mb-md-0">
                    <h5 className='fontWeight-500'>Lets Connect</h5>
                    <a href="https://www.facebook.com/futurristicbiz"> <FaFacebook className="me-3 fontSize-24 text-black" /></a>
                    {/* <a href=""> <FaTwitter className="me-3 fontSize-24 text-black" /></a> */}
                    <a href="https://www.instagram.com/futurristicbiz/"> <FaInstagram className='fontSize-24 me-3 text-black' /></a>
                    <a href="https://www.linkedin.com/company/futurristicbusinesssolutions" target="_blank" rel="noopener noreferrer"><FaLinkedin className='fontSize-24 me-3 text-black' /></a>
                    <a href="mailto:support@futurristic.com"> <BiLogoGmail className='fontSize-24 me-3 text-black' /> </a>
                    </Col>
                    <Col xs={12} md={6} className="text-center text-md-end mb-3 mb-md-0">
                            <Stack direction='vertical' gap={2}>
                                <h5>Address</h5>
                                <Stack direction='horizontal' gap={3} style={{
                                    justifyContent: 'end'
                                }}>
                                    <HiLocationMarker className='fontSize-24' />
                                    <h className='mb-0'>Ft. Lauderdale (USA), Indore (India)</h>
                                </Stack>
                            </Stack>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <p style={{
                                padding: '10px',
                                background: '#000',
                                color: '#fff',
                                marginTop: '20px'
                            }}>Copyright <FaRegCopyright /> 2024 | All Rights Reserved</p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    )
}

export default Footer
